<template>
  <div class="table -payout -payroll">
    <div class="t-tabs" :class="{ '-collumn': collumn }">
      <div :class="{ '-open': addDayOpen }" class="-tab -add">
        <i
          @click="addDayToggle"
          id="popover-mini-calendar"
          class="fas fa-plus"
        ></i>
        <b-popover
          target="popover-mini-calendar"
          placement="bottomright"
          custom-class="popover-calendar"
        >
          <custom-month-picker @picked="monthPicked" />
        </b-popover>
      </div>
      <div
        style="border-right: 1px solid white"
        :key="day.date"
        v-for="day in sort(payroll_months)"
        class="-tab"
        :class="{ '-active': currentMonth(day.date) }"
        @click="selectDate(day.date)"
        :title="$moment(day.date).format('YYYY') + ' г.'"
      >
        <span v-if="day">{{ yearBefore(day.date) }}</span>
      </div>
    </div>
    <div class="t-body">
      <h3>
        Начисления зарплаты
        <button
          style="margin-left: 5px"
          v-show="usersNotInList.length"
          @click="addUserPopover"
          id="popover-add-payroll"
        >
          добавить
        </button>
        <b-popover
          target="popover-add-payroll"
          placement="bottomleft"
          trigger="manual"
          custom-class="popover-add"
          @hide="closeAddUserPopover"
        >
          <ul>
            <li
              @click="toggleUserInList(u)"
              v-for="u in usersNotInList"
              :key="u._id"
            >
              <p>{{ u.first_name }} {{ u.last_name }}</p>
              <span v-if="userInList(u)">
                <i class="fas fa-check" aria-hidden="true"></i>
              </span>
            </li>
          </ul>
        </b-popover>
        <button v-if="payroll.length" @click="removeDate">удалить</button>
      </h3>
      <div class="t-head" v-if="noDataHide">
        <div class="-row">
          <div class="-cell">Имя</div>
          <div class="-cell">Начислено</div>
          <div class="-cell">Обновлено</div>
          <div class="-cell"></div>
        </div>
      </div>
      <micro-loading v-if="loading" />
      <div class="t-data" v-if="noDataHide">
        <div :key="p.id" v-for="p in payroll" class="-row">
          <div class="-cell">
            <p>{{ userName(p.owner) }}</p>
          </div>
          <div class="-cell">
            <span class="pseudo-input">{{
              $formatNumber(p.payroll || 0)
            }}</span>
            <input
              @input="$onlyNumber"
              :data-date="p.date"
              data-name="payroll"
              :data-owner="p.owner"
              @change="updateFinance"
              v-model="p.payroll"
              type="tel"
              :class="{ '-opacity': p.payroll }"
              @click="selectRange"
            />
          </div>
          <div class="-cell">
            <div
              v-if="p.last_update"
              class="-updated"
              :title="userName(p.last_update.email)"
            >
              <img
                v-if="userImage(p.last_update.email)"
                :src="$IMAGE(userImage(p.last_update.email))"
              />
              <span v-if="p.last_update.date">{{
                $moment(p.last_update.date).fromNow()
              }}</span>
            </div>
          </div>
          <div @click="removeUserFromList(p)" class="-cell -show-on-hover">
            <span>скрыть</span>
          </div>
        </div>
      </div>
      <div class="t-sum" v-if="noDataHide">
        <div class="-row">
          <div class="-cell"></div>
          <div class="-cell">{{ $formatNumber(counterPayroll) }}</div>
        </div>
      </div>
      <div class="t-data" v-if="noDataShow">
        <p class="no_data">Нет данных</p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      addDayOpen: false,
      collumn: false,
      loading: true,
      addUsers: [],
      addUserPopoverState: false,
      currentMonthDate: null
    };
  },
  computed: {
    ...mapState("finance", ["payroll", "payroll_months"]),
    ...mapState("app", ["users"]),
    ...mapGetters("app", ["resolveUser"]),
    ...mapGetters("finance", ["currentMonth", "counterPayroll"]),
    noDataHide() {
      return !this.loading && this.payroll.length;
    },
    noDataShow() {
      return !this.loading && !this.payroll.length;
    },
    usersNotInList() {
      return this.users.filter(
        user => !this.payroll.some(p => p.owner === user.email)
      );
    },
    userInList() {
      return user => this.addUsers.some(u => u.email === user.email);
    }
  },
  watch: {
    "this.$route"() {
      this.calcTabs();
    },
    payroll() {
      this.calcTabs();
    },
    payroll_days() {
      this.calcTabs();
    }
  },
  methods: {
    ...mapActions("finance", [
      "getPayroll",
      "getPayrollByMonth",
      "addPayrollMonth",
      "updatePayroll",
      "removePayrollMonth",
      "addUsersPayroll",
      "removeUserPayroll"
    ]),
    yearBefore(date) {
      let result = this.$moment(date).format("MMMM");
      if (new Date().getFullYear() > new Date(date).getFullYear())
        result = this.$moment(date).format("MMM YYYY");
      return result;
    },
    selectRange(ev) {
      if (ev.target.value === "0") ev.target.select();
    },
    closeDayOpen() {
      this.$nextTick(() => {
        this.addDayOpen = false;
      });
    },
    async monthPicked(data) {
      await this.addPayrollMonth(data);
    },
    calcTabs() {
      // set flex collumn when tabs width > tab-scroll width
      const tabsWidth = document.querySelector(".t-tabs").offsetWidth;
      const allWidth = this.payroll_months.length * 80 + 80;
      this.collumn = allWidth > tabsWidth;
      this.loading = false;
    },
    addDayToggle() {
      this.addDayOpen = !this.addDayOpen;
    },
    sort(arr) {
      if (arr) return arr.slice().sort((a, b) => b.date - a.date);
    },
    userImage(email) {
      try {
        const { image } = this.resolveUser(email);
        return image;
      } catch (e) {
        void e;
        return null;
      }
    },
    userName(email) {
      try {
        const { first_name, last_name } = this.resolveUser(email);
        if (first_name && last_name) {
          if (this.$mediaQuery() === "mobile")
            return `${first_name.charAt(0)}. ${last_name}`;
          else return `${first_name} ${last_name}`;
        } else {
          return email;
        }
      } catch (e) {
        void e;
        return email;
      }
    },
    async selectDate(date) {
      this.addUsers = []; // reset
      await this.getPayrollByMonth({ date: parseInt(date) });
      this.currentMonthDate = date;
    },
    updateFinance(ev) {
      const { date, owner } = ev.target.dataset;
      const { value } = ev.target;

      this.updatePayroll({
        payroll: value ? parseInt(value.replace(/\s/g, "")) : 0,
        date: parseInt(date),
        owner: owner
      });
    },
    removeDate() {
      const date = this.payroll[0].date;
      const question = `Подтверждаете удаление данных о начислениях за ${this.$moment(
        date
      ).format("MMMM YYYY")}? <br><br> Действие необратимо.`;
      this.$root
        .$confirm({
          header: "Удаление данных",
          body: question,
          agree: "Подтверждаю",
          cancel: "Отмена"
        })
        .then(async () => {
          await this.removePayrollMonth({ date });
          if (this.payroll_months.length)
            this.selectDate(this.payroll_months[0].date);
        })
        .catch(e => void e);
    },
    closeAddUserPopover() {
      if (this.addUsers.length) {
        this.addUsersPayroll({
          users: this.addUsers,
          month: this.currentMonthDate
        });
        this.$nextTick(
          async () =>
            await this.getPayrollByMonth({ date: this.currentMonthDate })
        );
        this.addUsers = [];
      }
      this.addUserPopoverState = false;
    },
    addUserPopover() {
      this.addUserPopoverState = true; //!this.addUserPopoverState
    },
    removeUserFromList(p) {
      this.removeUserPayroll({ date: this.currentMonthDate, owner: p.owner });
      this.$nextTick(
        async () =>
          await this.getPayrollByMonth({ date: this.currentMonthDate })
      );
    },
    toggleUserInList(user) {
      const index = this.addUsers.findIndex(u => u._id === user._id);
      index > -1 ? this.addUsers.splice(index, 1) : this.addUsers.push(user);
    }
  },
  async mounted() {
    await this.getPayroll();
    this.$nextTick(() => {
      setTimeout(() => {
        this.calcTabs();
        try {
          this.currentMonthDate = this.payroll[0].date;
        } catch (e) {
          void e;
        }
      }, 200); //fix tabs
    });
    window.onresize = () => {
      if (this.$route.name === "finance_payroll") this.calcTabs();
    };

    // activate last created month
    this.selectDate(this.sort(this.payroll_months)[0].date);
  }
};
</script>
